export enum ORDER_STATUS {
  NEW = 6,
  SCHEDULED = 7,
  ARRIVED = 0,
  IN_PROGRESS = 8,
  SUSPENDED = 9,
  COMPLETED = 5,
  READING = 1,
  SUBMITTED = 2,
  APPROVED = 3,
  CANCEL = 4,
}

export const ORDER_MATCH_STATUS = {
  UNMATCH: false,
  MATCH: true,
};

export enum ORDER_PRIORITY {
  LOW,
  MEDIUM,
  ROUTINE,
  HIGH,
  STAT,
}

export const ORDER_COLUMNS_SETTING = 'col_order_columns_setting';

export const ORDER_COLUMNS_ORIGINAL = 'col_order_columns_original';

export const statusMappingAction = {
  NEW: ['Schedule', 'Cancel'],
  SCHEDULED: ['New', 'Cancel'],
  ARRIVED: ['Start', 'Cancel'],
  IN_PROGRESS: ['Complete', 'Suspend', 'Cancel'],
  SUSPENDED: ['Continue'],
  CANCEL: ['Schedule'],
};

export const actionStatusMapping = {
  Schedule: ORDER_STATUS.SCHEDULED,
  Receive: ORDER_STATUS.ARRIVED,
  Start: ORDER_STATUS.IN_PROGRESS,
  Complete: ORDER_STATUS.COMPLETED,
  Suspend: ORDER_STATUS.SUSPENDED,
  Cancel: ORDER_STATUS.CANCEL,
  Continue: ORDER_STATUS.IN_PROGRESS,
  New: ORDER_STATUS.NEW,
};

export const statusLabelMap = {
  NEW: { label: 'Create At', user: 'Create By' },
  SCHEDULED: { label: 'Schedule At', user: 'Schedule By' },
  ARRIVED: { label: 'Arrive At', user: 'Arrive By' },
  IN_PROGRESS: { label: 'Start At', user: 'Start By' },
  SUSPENDED: { label: 'Suspend At', user: 'Suspend By' },
  COMPLETED: { label: 'Complete At', user: 'Complete By' },
  READING: { label: 'Reading At', user: 'Reading By' },
  SUBMITTED: { label: 'Submit At', user: 'Submit By' },
  APPROVED: { label: 'Approve At', user: 'Approve By' },
  CANCEL: { label: 'Cancel At', user: 'Cancel By' },
};
